<template>  
    <div class="section" >
        <div class="tile is-ancestor toppmargin">
            <div class="tile is-parent">
                <article class="tile is-child box bokswhite">
                    <!-- VÅR HISTORIE - I EN MODAL -->
                    <p class="has-text-centered">
                        <img src="@/assets/images/pizzeria/pizzeria_logo.svg" width="565px" alt="Pizzeria del Generale Logo" />
                    </p>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box boksblack" style="padding:14px 5px 0px 5px;">
                    <video-player 
                        :options="videoOptions"             
                        class="has-text-centered vjs-16-9"        
                    />
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box bokswhite">
                    <p class="has-text-centered">
                        <a href="./static/pdf/meny_2019_v1_screen.pdf" target="_blank" alt="Pizzeriamenyen">
                            <img src="@/assets/images/pizzeria/menyvindu.jpg" width="560px" alt="Pizzeriameny" />
                        </a>
                    </p>
                </article>
            </div>
        </div>

        <div class="has-text-centered" style="margin-top:2vw; margin-bottom: 2vw;">
            <!-- <a class="button is-large is-success" target="_self" href="https://www.reservasjoner.no/book/take-away">
                Bestill takeaway her!
            </a> -->
            <a class="button is-large is-success" target="_self" href="https://www.reservasjoner.no/book/bordbestilling" style="margin-left:1em;">
                Bestill bord her!
            </a>            
        </div>

        <!-- ARTIKKELVELGER -->
        <!-- <div class="tile is-ancestor">
            <div class="tile is-parent">
                <article class="tile is-child box bokswhite has-text-centered" style="padding:5px 5px 0px 5px;">
                    <a @click="artikkelValg(1)">
                        <img src="@/assets/images/pizzeria/al_taglio_960px.jpg"/>
                    </a>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box bokswhite has-text-centered" style="padding:5px 5px 0px 5px;">
                    <a @click="artikkelValg(2)">
                        <img src="@/assets/images/pizzeria/pizzakurs_960px.jpg" />
                    </a>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box bokswhite has-text-centered" style="padding:5px 5px 0px 5px;">
                    <a @click="artikkelValg(3)">
                        <img src="@/assets/images/pizzeria/pizza_strada_960px.jpg" />
                    </a>
                </article>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box bokswhite has-text-centered" style="padding:5px 5px 0px 5px;">
                    <a @click="artikkelValg(4)">
                        <img src="@/assets/images/pizzeria/samlinger_960px.jpg" />
                    </a>
                </article>
            </div>
        </div> -->

        <!-- ARTIKLER HER -->
        <div class="columns is-centered" style="margin-top: 2vw;">
            <div class="column is-three-quarters boksblack">

                <!-- ARTIKKEL 0 - DEFAULT -->
                <article class="has-text-white" v-if="this.artikkel == 0">
                    <h2 class="title has-text-primary has-text-centered">Pizzeria del Generale hadde sin siste åpningsdag søndag 27.06.2021</h2>
                    <p class="is-size-5 is-size-6-mobile">Pizzeria del Generale åpnet i 2010 og vi har hatt nesten 11 fantastiske år i drift. Svært mange trivelige stamgjester, stadig utvikling og kompetanseheving samt noen artige events vi for alltid kommer til å huske med glede. </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">Men det er en tid for alt - og nå som det ikke lar seg gjøre å drifte et lite hotell på Helgelandsmoen, så må også pizzeriaen avvikles. Men hvem vet - kanskje dukker den opp i ny drakt et annet sted til en annen tid?</p>
                    <!-- <p class="is-size-5 is-size-6-mobile avsnitt">Vi har 2 helger igjen før vi stenger (18-20.06 og 25-27.06) og håper så mange som vi har plass til besøker oss da for en siste pizza. Magefølelsen vår sier at det absolutt vil lønne seg å reservere bord disse dagene. Merk at vi <u>ikke</u> kommer til å kjøre takeaway da vi regner med såpass stor pågang i restauranten at ovnen neppe vil ha kapasitet til det.</p> -->
                    <p class="is-size-5 is-size-6-mobile avsnitt has-text-centered">Takk for alle besøk og rosende ord! Arrivederci. </p>
                </article>


                <!-- ARTIKKEL 0 - DEFAULT -->
                <!-- <article class="has-text-white" v-if="this.artikkel == 0">
                    <h2 class="title has-text-primary">Kort om Pizzeria del Generale</h2>
                    <p class="is-size-5 is-size-6-mobile">Pizzeria del Generale åpnet i 2010. Vi sier restauranten ligger i Hønefoss, men det de færreste vet er at den faktisk er plassert et par hundre meter over grensen til Hole - og er vel reelt sett som et spisested i Hole å regne.</p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">Restauranten er familiedrevet og vi satser på de beste råvarene vi kan få både lokalt og fra Italia.</p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">Med vår vedfyrte steinovn har restauranten scoret høyt på TripAdvisor sine rangeringer helt siden vi åpnet. Vi opplever ofte at våre gjester kjører helt fra Bærum, Asker, Sandvika og Drammen for å spise vår pizza. Fra Sandvika er det jo ikke mer enn 25 minutter med bil.</p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">Vi gjør selvsagt takeaway - og du kan bestille her på våre nettsider.</p>
                </article> -->

                <!-- ARTIKKEL 1 - AL TAGLIO -->
                <article class="has-text-white" v-if="this.artikkel == 1" id="artikkelen">
                    <figure class="image artikkelbilde">
                        <img src="@/assets/images/pizzeria/al_taglio_960px.jpg" alt="Pizza al Taglio " />
                    </figure>
                    <h2 class="title has-text-primary">Pizza al Taglio</h2>
                    <p class="is-size-5 is-size-6-mobile">
                    ... som helt enkelt betyr "skåret pizza", er en meny hvor vi fortløpende steker like mange av våre 4 mest solgte pizze som det finnes gjester. Så skjærer vi pizzaene i klassiske stykker og serverer på bordet.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                    På en måte blir det som buffet, men med et litt større spekter av smaker - og ingen må reise seg for å fylle på. På denne måten får selv større grupper maten på bordet nokså raskt og alle gjestene får en gylden anledning til å identifisere sin favorittpizza (til senere bruk)!!</p>

                    <p class="is-size-5 is-size-6-mobile avsnitt">
                    Pris = kr. 170,-/voksen<br/>
                    kr. 90,- for barn 6-12 år<br/>
                    kr. 30,- for barn 3-5 år<br/>
                    kr. 0,- for barn under 3 år<br/>
                    Minimum 12 personer<br/>
                    </p>
                    
                    <h3 class="title is-size-4 has-text-white mellomtittel">Diverse alternative tillegg</h3>
                    <p class="is-size-5 is-size-6-mobile">
                    Hjemmelaget iskrem og biscotti = kr. 65,-/gjest<br/>
                    Assortert mineralvann = kr. 39,-/flaske<br/>
                    Kaffe/te = kr. 30,-/kopp
                    </p>

                    <h3 class="title has-text-white mellomtittel">Oppgjørsformer</h3>
                    <p class="is-size-5 is-size-6-mobile">
                    For grupper over 12 gjester setter vi pris på om mesteparten av oppgjøret kan tas med 1 av gjestene. Med andre ord er det en fordel med lik sum for hver enkelt gjest. Ønsker man at alle gjestene skal velge sitt eget drikke a la carte, vil regningene bli veldig forskjellige og oppgjøret vil ta mye tid - det er derfor fint om man kan gjøre opp bord for bord under slike omstendigheter. Det er fullt mulig å dele alle oppgjør slik at man betaler både med kort og kontant. For grupper på over 20 personer må oppgjørsform avtales på forhånd.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                    Kreditt gis til bedrifter og foreninger all den tid det er avtalt på forhånd (grupper over 12 gjester).
                    </p>
                    <h3 class="title has-text-white mellomtittel">Antallsjusteringer</h3>
                    <p class="is-size-5 is-size-6-mobile">
                    Vi setter pris på å bli sekundert noen timer i forkant dersom det er større kjente antallsjusteringer, men dere betaler selvsagt ikke for gjester som faller fra den orginale bestillingen. Sekundèr gjerne på telefon 32 16 00 00 eller til resepsjon@generalhotell.no.</p>
                    
                    <h3 class="title has-text-white mellomtittel">Booking</h3>
                    <p class="is-size-5 is-size-6-mobile">
                    Du kan godt bestille al taglio via vår <a href="https://www.reservasjoner.no/book/bordbestilling" target="_self">onlinebooking</a>. Bare notèr i kommentarfeltet hvilke tillegg dere eventuelt ønsker og hvor mange barn kontra voksne dere er.
                    </p>
                </article>

                <!-- ARTIKKEL 2 - PIZZAKURS -->
                <article class="has-text-white" v-if="this.artikkel == 2" id="artikkelen">
                    <figure class="image artikkelbilde">
                        <img src="@/assets/images/pizzeria/pizzakurs_960px.jpg" alt="Pizzakurs" />
                    </figure>
                    <h2 class="title has-text-primary">Prøv ett av våre pizzakurs!</h2>
                    <p class="is-size-5 is-size-6-mobile">                
                        Igjennom 10 år har vi utviklet vår pizzakompetanse og vår interesse for alle aspekter av pizzabaking har aldri vært større enn nå. I dette pizzakurset byr Jonas på både teoretiske og faktiske smaksprøver.
                        Opplegget er raffinert over flere år og vi vet av erfaring at det treffer godt og bredt.
                    </p>
                    <h3 class="title has-text-white mellomtittel">Kursopplegg</h3>
                    <p class="is-size-5 is-size-6-mobile"> 
                        TEORETISK
                        <ul class="liste">
                            <li>Om vår pizzeria og vår reise</li>
                            <li>Historien om ovnene</li>
                            <li>Historien om pizza</li>
                            <li>Historien om ingrediensene</li>
                            <li>Historien om de forskjellige pizzaypene</li>
                            <li>Deigen</li>
                        </ul>
                        DEMONSTRASJON OG SMAKSPRØVER
                        <ul class="liste">
                            <li>Hva kjennetegner en bra pizzabunn?</li>
                            <li>Smaking av forskjellige tomater</li>
                            <li>Smaking av forskjellige oster</li>
                            <li>Hvordan bake ut pizza?</li>
                            <li>Hvordan steke pizza?</li>
                        </ul>
                        MÅLTIDET
                        <ul class="liste"> 
                            <li>Gruppen setter seg ned og spiser seg "igjennom menyen" - veiledet av vår pizzaiolo.</li>
                        </ul>
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">                
                        Hele opplegget varer rett i underkant av 4 timer med naturlige pauser. Om gruppen er på under 10 personer, så får alle mulighet til å prøve seg på utbaking av pizza under kyndig veiledning. Er gruppen på over 10 personer, så er det dessverre ikke nok tid til å gjennomføre dette - så da gjør vi en skikkelig demonstrasjon og så får et par utvalgte kandidater prøve seg. Kaffe og sjokolade serveres under teoridelen.
                    </p>
                    
                    <h3 class="title has-text-white mellomtittel">Pris</h3>
                    <p class="is-size-5 is-size-6-mobile">                
                        Kr. 4.000,- + 230,-/person inklusive mva.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">                
                        Prisen inkluderer ikke drikke under måltidet.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt has-text-centered">                
                        <a class="button is-success is-large" href="mailto:jonas@generalhotell.no?subject=Pizzakurs">SEND EN FORESPØRSEL I DAG!</a>
                    </p>
                </article>

                <!-- ARTIKKEL 3 - PIZZA PÅ HJUL -->
                <article class="has-text-white" v-if="this.artikkel == 3" id="artikkelen">
                    <figure class="image artikkelbilde">
                        <img src="@/assets/images/pizzeria/pizza_strada_960px.jpg" alt="Pizza på hjul" />
                    </figure>
                    <h2 class="title has-text-primary">Pizzeria del Generale sulla strada</h2>
                    <p class="is-size-5 is-size-6-mobile">    
                        I 2019 hadde vi et stort event og kjøpte en veldig bra mobil, vedfyrt, steinovn. Ovnen er fra Sicilia og i bunnen finnes en tykk steinplate fra vulkanen Etna. Den veier 300 kg, så det er litt å drasse rundt på - men den lager fantastiske pizze. Faktisk synes vi bunnen i denne ovnen nesten overgår den steinbunnen vi har i pizzeriaen.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Om du er interessert i få besøk av en pizzeria til ditt jubileum, sommerfest, festival/konsert eller markedsdag - så ta kontakt for skreddersydde tilbud.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Pizzeria del Generale sulla Strada er et konsept som består av et komplett kjøkkentelt med vedfyrt steinovn. Til grupper serveres maten på buffet ved steinovnen og vi steker små, autentiske, napoletanske Margherita pizza. Man kan også plukke litt garnityr - som parmaskinke, diverse salame, diverse grønnsaker og salat - fra tilstøtende buffet. Vårt mobile kjøkken er også rigget for å servere drikke.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Vi har andre ideer om å servere alt fra bakte poteter til komplette grillmiddager fra samme kjøkken, men det får komme litt etter hvert. Har du imidlertid et brennende ønske, så ikke nøl med å ta kontakt. Vi liker utfordringer!
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Konseptet passer best for grupper fra 30 til 100 personer. Vår erfaring så langt er at konseptet nok er litt i dyreste laget for de fleste små (-30 personer) private hageselskaper - men vi skriver selvsagt tilbud til alle som spør! Pris får du foreløpig på forespørsel, men etter hvert vil vi nok utvikle enkelte ferdige prisede pakkeløsninger. Ta kontakt i dag for et uforpliktende tilbud!        
                    </p>           
                    <p class="is-size-5 is-size-6-mobile avsnitt has-text-centered">                
                        <a class="button is-success is-large" href="mailto:jonas@generalhotell.no?subject=Strada">SEND EN FORESPØRSEL I DAG!</a>
                    </p>     
                </article>

                <!-- ARTIKKEL 4 - Samlinger med barn -->
                <article class="has-text-white" v-if="this.artikkel == 4" id="artikkelen">
                    <figure class="image artikkelbilde">
                        <img src="@/assets/images/pizzeria/samlinger_960px.jpg" alt="Samlinger med barn" />
                    </figure>
                    <h2 class="title has-text-primary">Samlinger med barn</h2>
                    <p class="is-size-5 is-size-6-mobile">
                        Det blir stadig mer populært å feire bursdagen, fotballavsluttningen eller skoleavsluttningen på Pizzeria del Generale. Vi dekker opp med italiensk stemning og serverer pizza etter spis-så-mye-du-vil-prinsippet!
                    </p>
                    <h3 class="title is-size-4 has-text-white mellomtittel">Priser og menyvalg</h3>
                    <p class="is-size-5 is-size-6-mobile">
                        Barn over 12 år spiser mer enn 6-åringer - og voksne spiser enda mer, så derfor finnes det tre priser på de forskjellige produktene. Brus og dessert er selvsagt valgfrie tillegg.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Om det er færre enn 5 voksne i arrangementet, så kan disse godt få velge mat direkte fra vår a la carte meny. Prisen blir da deretter. Er det flere enn 5 voksne, må dere nesten bli med på samme meny som barna. Takk for at du gir beskjed om hvordan dere vil ha dette på forhånd.
                    </p>
                    
                    <table border="0px" class="table is-striped is-hoverable" style="margin-top:25px;"> 
                        <tbody>
                            <tr>
                                <th>PRODUKT</th>
                                <th>6-12 ÅR</th>
                                <th>13-16 ÅR</th>
                                <th>Voksne</th>
                            </tr>
                            <tr>
                                <td colspan="4"><em>Pizzameny</em></td>
                            </tr>
                            <tr>
                                <td>Meny "Classico" <br><small>&nbsp;&nbsp;- Pizza Margherita + Prosciutto Cotto (50-50)</small></td>
                                <td align="right" valign="top">kr. 80,-</td>
                                <td align="right" valign="top">kr. 130,-</td>
                                <td align="right" valign="top">kr. 145,-</td>
                            </tr>
                            <tr>
                                <td>Meny "Arrabbiato" <br><small>&nbsp;&nbsp;- Prosciutto Cotto + Indiavolata (50-50)</small></td>
                                <td align="right" valign="top">kr. 90,-</td>
                                <td align="right" valign="top">kr. 140,-</td>
                                <td align="right" valign="top">kr. 165,-</td>
                            </tr>
                            <tr>
                                <td><em>Valgfrie tillegg</em></td>
                                <td colspan="3">&nbsp;&nbsp;<small>Samme pris for barn/voksen</small></td>
                            </tr>
                            <tr>
                                <td>Assortert mineralvann</td>
                                <td align="right">kr. 39,-</td>
                                <td colspan="2"></td>
                            </tr>
                            <tr>
                                <td>Husholdningssaft</td>
                                <td align="right">kr 10,-</td>
                            </tr>
                            <tr>
                                <td>1 stor kule iskrem</td>
                                <td align="right">kr. 30,-</td>
                                <td colspan="2"></td>
                            </tr>
                            <tr>
                                <td>3 kuler iskrem</td>
                                <td align="right">kr. 60,-</td>
                                <td colspan="2"></td>
                            </tr>
                            <tr>
                                <td>Sjokoladekake med seigmenn og lys <br><small>(inneholder melk!)</small></td>
                                <td align="right" valign="top">kr. 45,-</td>
                                <td colspan="2"></td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 class="title is-size-4 has-text-white mellomtittel">Betingelser</h3>
                    <p class="is-size-5 is-size-6-mobile">
                        Prisene gjelder kun for grupper større enn 10 deltagere. Antallsjusteringer kan gjøres helt frem til arrangementstart.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Selskapet gjøres normalt opp på stedet - kreditt må avtales på forhånd. Om det er flere enn 20 gjester i følget, må måltidet gjøres opp før dere går til bords. Unntaket fra denne regelen er om 1 person gjør opp for alt. Da kan oppgjøret skje når som helst.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Husk å gi beskjed om matallergier dersom du kjenner noen! Vi har glutenfri pizza også. Vi tillater dessverre ikke medbragte kaker, med mindre det er av dietthensyn.
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt">
                        Dere må selv sørge for at det er tilstrekkelig antall voksne til å passe på barna.
                    </p>
                    <h3 class="title is-size-4 has-text-white mellomtittel">Bestilling</h3>
                    <p class="is-size-5 is-size-6-mobile">
                        Du kan ringe inn din forespørsel på telefon 32 16 00 00 eller sende oss en e-post. 
                    </p>
                    <p class="is-size-5 is-size-6-mobile avsnitt has-text-centered">                
                        <a class="button is-success is-large" href="mailto:booking@generalhotell.no?subject=Barneselskap">SEND EN FORESPØRSEL I DAG!</a>
                    </p>                         
                </article>     

            </div>
        </div>


    </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
	name: "Pizzeria",
	components: {
		VideoPlayer
    },
    metaInfo: {
        title: 'Pizzeria del Generale er hotellets restaurant i Hønefoss ',
        meta: [
        { name: 'description', content: 'Pizzeria del Generale er General Hotell sin a la carte restaurant. Klassisk restaurant i Hønefoss. Plassert på grensen til Hole. Vi tilbyr deilig italiensk pizza tilberedt i vedfyrt steinovn - samt pasta og salater.'},
        { name: 'keywords', content: 'pizzeria, trattoria, pizza, pasta, restaurant, spisested, takeout, take out, takeaway, take away' },    
        ]
    },    
	data() {
		return {
			videoOptions: {
                controls: true,
                loop: true,                
                fluid: true,  
                aspectRatio: "16:9", 
                poster: "https://image.mux.com/WaFEBh01fEdEUKBerXvXpkJ019gPCPJpP5IYE5UFCC7V8/thumbnail.png?time=1&fitmode=true",
				sources: [
					{
						src:
							"https://stream.mux.com/WaFEBh01fEdEUKBerXvXpkJ019gPCPJpP5IYE5UFCC7V8.m3u8",
                        type: "application/x-mpegURL",                        
					}
				]
			},
            artikkel: 0       
        }
	},
    methods: {
        // artikkelValg(x) {
        //     this.artikkel = x;
        //     location.href = "#artikkelen"
        // },
        // advarsel() {
        //     this.$buefy.snackbar.open({
        //         message: `
        //                 <p class="is-size-5 is-size-6-mobile has-text-weight-bold ">COVID-19</p>
        //                 <p class="is-size-5 is-size-6-mobile">Pizzeria del Generale er dessverre kun åpen fredag-søndag for tiden. Vi håper å snarest mulig kunne returnere til vanlige åpningstider.</p>
        //                 <p class="is-size-6 is-size-7-mobile has-text-weight-light" style="margin-top:0.5vw;">Our restaurant only open Friday through Sunday for the moment, due to Covid-19.</p>
        //                 `,
        //         position: 'is-top',
        //         type: 'is-danger',
        //         actionText: 'Lukk',
        //         indefinite: true,
        //     })    
        // }        
    },
    mounted(){
        // this.advarsel();
    }    
};

</script>

<style scoped>
.bokswhite {
    /*background-color: #383838; */
    background-color: #ffffff;
    border: 1px solid #000000;    
}

.boksblack {
    /*background-color: #383838; */
    background-color: #000000;
    border: 1px solid #ffffff;    
}

.toppmargin {
    margin-top:0vw;
}

.artikkelbilde {
    margin-left: 20px;
    width: 25vw;
    height: auto;
    display: block;
    float: right;
}

.mellomtittel {
    margin-top: 1.5vw;
    margin-bottom: 0.5vw;
}

.avsnitt {
    margin-top:1vw;
}

.liste {
    list-style-type: circle;
    margin-left:2vw;
}
</style>

